const SYSTEM_ACL_BASE_PATH = '/system/security/access-control';

export function buildSystemAclListPath() {
  return SYSTEM_ACL_BASE_PATH;
}

export function buildSystemAclNewPath() {
  return `${SYSTEM_ACL_BASE_PATH}/new`;
}

export function buildSystemAclEditPath(roleId) {
  const normalizedRoleId = String(roleId || '').trim();
  if (!normalizedRoleId) {
    return SYSTEM_ACL_BASE_PATH;
  }

  return `${SYSTEM_ACL_BASE_PATH}/${encodeURIComponent(normalizedRoleId)}`;
}

export function getSystemAclEditorMode(params) {
  const normalizedRoleId = String(params?.roleId || '').trim();

  if (!normalizedRoleId || normalizedRoleId === 'new') {
    return {
      mode: 'create',
      roleId: null,
    };
  }

  return {
    mode: 'edit',
    roleId: normalizedRoleId,
  };
}
